import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { startLoadingNotificationsByProject } from '../../actions/notification';
import buildMiddleware from './template';
const withNotificationsFetch = SubComponent => {
  const WithNotificationsFetchWrapper = buildMiddleware(SubComponent, 'WithNotifications');
  const WithNotificationsFetch = class extends Component {
    componentDidMount() {
      this.props.startLoadingNotificationsByProject();
    }
    render() {
      const {
        startLoadingNotificationsByProject,
        ...passThroughProps
      } = this.props;
      return /*#__PURE__*/React.createElement(WithNotificationsFetchWrapper, passThroughProps);
    }
  };
  const mapStateToProps = _ref => {
    let {
      notification
    } = _ref;
    return {
      loading: notification.notificationsLoading || !notification.notifications && !notification.notificationsError,
      error: notification.notificationsError
    };
  };
  const mapDispatchToProps = dispatch => ({
    startLoadingNotificationsByProject: () => dispatch(startLoadingNotificationsByProject())
  });
  WithNotificationsFetch.propTypes = {
    startLoadingNotificationsByProject: PropTypes.func.isRequired
  };
  return connect(mapStateToProps, mapDispatchToProps)(WithNotificationsFetch);
};
export default withNotificationsFetch;